import { render, staticRenderFns } from "./TabelaResultado.vue?vue&type=template&id=d832d0c8&scoped=true"
import script from "./TabelaResultado.vue?vue&type=script&lang=js"
export * from "./TabelaResultado.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=d832d0c8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d832d0c8",
  null
  
)

export default component.exports